import { actionTypes, HideTimeout } from "./Actions";

const hideTimeout: HideTimeout = () => ({
  type: actionTypes.HIDE_TIMEOUT
});

export default hideTimeout;
